import config from "@Config/index";
import axios from "axios";
import { filterActiveChildInventories } from "../RecentelyViewedSection/helper";
import { getFilterParams } from "@Pages/Search/data/helper";

export const getInventorySimilar = async (id: any, options: any = {}) => {
  const finalOptions = {
    ...options,
  };
  const res: any = await axios.get(
    `${config.API_URL}/api/v0/inventories/${id}/similar`,
    finalOptions,
  );
  if (res?.data?.result && (!options.status || options.status !== "all")) {
    res.data.result = filterActiveChildInventories(res.data.result);
  }
  return res;
};

const filterPriorityDataBasedOnUnitType = (data: any) => {
  const priorityData: any[] = [];
  const normalData: any[] = [];

  // eslint-disable-next-line array-callback-return
  data?.forEach((item: any) => {
    if (
      item?.meta?.unit_type === "student_accommodation" ||
      item?.meta?.unit_type === "apartment"
    ) {
      priorityData.push(item);
    } else {
      normalData.push(item);
    }
  });
  return [...priorityData, ...normalData];
};

export const getNearbyProperties = async (id: any) => {
  let finalData: any = [];
  const NearbyApiOptions = {
    params: {
      limit: 10,
      region_radius: 20000,
      region_type: "circle",
      sort_key: "relevance_sorting_v2",
      sort_order: "desc",
      statuses: "active",
      use_open_search: true,
      only: "id,name,canonical_name,available,location,pricing,images,reviews_rating,meta",
      type: "empty",
      methods: "meta_short,amber_sales",
    },
  };
  const response = await getInventorySimilar(id, NearbyApiOptions);
  if (response?.data?.data?.result?.length > 0) {
    finalData = response?.data?.data?.result;
  }

  finalData = filterPriorityDataBasedOnUnitType(finalData);
  return finalData;
};

export const getInventoriesforIds = async (idArray: any, options: any = {}) => {
  const dataArray = idArray.join(",");
  const finalOptions = {
    ...options,
    params: { ...(options.params || {}), use_java_api: true },
    headers: { ...(options.headers || {}), "X-Use-Java-Api": "true" },
  };
  const res: any = await axios.get(
    `${config.API_URL}/api/v1/inventories?ids=${dataArray}`,
    finalOptions,
  );
  if (res?.data?.result && (!options.status || options.status !== "all")) {
    res.data.result = filterActiveChildInventories(res.data.result);
  }
  return res;
};

export const getInventorySimilarById = async (options: any = {}) => {
  const INVENTORY_LIMIT = 10;
  let result = null;
  try {
    result = await axios.post(`${config.SIMILAR_PROPERTIES_URL}/similar_properties`, options);
  } catch (error) {
    console.error(error);
  }

  const parsedResult = result && Array.isArray(result.data) ? result.data : [];
  const inventoryId = options?.inventory_id;

  const sortedParsedResult = [...parsedResult].sort((a, b) => {
    if (a.distance !== b.distance) {
      return a.distance - b.distance;
    }
    return a.price - b.price;
  });

  const ids = sortedParsedResult.map((item) => item.index);

  const inventoryOptions = {
    params: {
      ids: ids.map(String).join(","),
      ...getFilterParams({
        available: true,
        limit: INVENTORY_LIMIT,
        root: true,
        type: "empty",
        status: "active",
        only: "id,name,canonical_name,available,location,pricing,images,reviews_count,reviews_rating,top_meta_distances,meta",
        methods: "meta_short,images_with_featured",
        child_images_in_root: true,
      }),
      ...(options?.user_currency ? { user_currency: options.user_currency } : {}),
    },
  };

  const response = await getInventorySimilar(inventoryId, inventoryOptions);
  let data = response?.data?.data || [];
  if (data) {
    data = [...data].sort((a, b) => {
      if (a.available === b.available) return 0;
      return a.available ? -1 : 1;
    });
  }
  return data;
};
